import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import apiClient from "../services/apiClient"
import { getAccessToken, setAccessToken, setAccountTokens } from "../services/apiClient"

interface LoginRestrictProps {
  children: React.ReactNode
}

const LoginRestrict: React.FC<LoginRestrictProps> = ({ children }) => {
  const navigate = useNavigate()
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    // Already authenticated in this session — redirect away from login
    if (getAccessToken()) {
      navigate("/dashboard")
      return
    }

    apiClient
      .post("/auth/refresh", undefined, { withCredentials: true })
      .then((res) => {
        const data = res.data?.data || {}
        setAccessToken(data.authToken)
        if (data.accounts?.length) setAccountTokens(data.accounts)
        navigate("/dashboard")
      })
      .catch(() => {
        // No valid session — show the login form
        setChecked(true)
      })
  }, [navigate])

  if (!checked) return null

  return <>{children}</>
}

export default LoginRestrict
